<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiArrowLeft } from "@mdi/js";
export default {
  name: "MdiArrowLeft",
  data() {
    return {
      svgPath: mdiArrowLeft,
    };
  },
};
</script>
